import {Col, ColType, Crud, CrudApi} from "../../comp/crud";
import {ApiClient, ApiDocInfo, displayTeamManagerStatus, getTeamManagerStatusOpt} from "../../api/ApiClient";
import {useContext, useEffect, useState} from "react";
import { Form, Modal, Typography,Tag } from '@douyinfe/semi-ui';
let apiClient = ApiClient.getDefault();
const { Text } = Typography;
export default function TeamManager(){
    const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
    useEffect(() => {
        
    }, [])
    let cols: Col[] = [
        {
            name: "ID",
            key: "id",
            hideInEdit: true,
            type: ColType.STRING
        },
        {
            name: "团队",
            key: "teamId",
            type: ColType.TREE,
            getOptions: (row) => apiClient.getTeamAsOpts(),
            hideInList: true,
            showInFilter: true,
            hideInEdit: true,
          },
          {
            name: "团队",
            key: "teamName",
            type: ColType.STRING,
            hideInEdit: true,
            hideInCreate: true,
          },
        {
            name: "负责人",
            key: "name",
            type: ColType.STRING,
            hideInEdit: true,
            hideInCreate: true,
          },
          {
            name: "负责人",
            key: "mainUserId",
            type: ColType.SELECT,
            getOptions: (row) => apiClient.getUserAsOpts(),
            hideInList: true,
            hideInEdit: true,
          },
       
        {
            name: "状态",
            key: "status",
            type: ColType.SELECT,
            showInFilter:true,
            getOptions: (row) => Promise.resolve(getTeamManagerStatusOpt()),
            render: (value, index) => {
                if (value == "ENABLED") {
                  return (
                    <Tag color="green" key={value} size='large'
                    shape='circle'
                    type='solid'> {displayTeamManagerStatus(value)} </Tag>
                  );
                } else   {
                  return (<Tag color="red" key={value} size='large'
                  shape='circle'
                  type='solid'> {displayTeamManagerStatus(value)} </Tag>);
                }
            }
        },
        {
            name: "创建时间",
            key: "createdAt",
            type: ColType.DATETIME,
            hideInEdit: true,
            hideInCreate: true,
        },
        {
            name: "更新时间",
            key: "updatedAt",
            type: ColType.DATETIME,
            hideInEdit: true,
            hideInCreate: true,
        },
    ]

   

    return <>
        <Crud
             getCrudApi={(crudApi) => {
                setCrudApi(crudApi);
              }}
            canUpdate={true}
            canCreate={true}
            name="团队负责人"
            entityKey="teamManagers"
            pageSize={50}
            getRowActions={(a) => [
               
            ]}
            cols={cols}
        />
    </>
}